// src/components/molecules/SubmissionDetails/ImageDisplaySection.js

import React, { useEffect } from "react";
import { Box } from "@mui/material";

const ImageViewer = ({ holding }) => {

  useEffect(() => {
    const img = new Image();
    img.src = `https://swayer.blob.core.windows.net/${holding.artworkId}-pub/_thumb_large.jpg`;
  }, [holding]);

  return (
    <Box display="flex" justifyContent="center">
      <Box
        component="img"
        src={`https://swayer.blob.core.windows.net/${holding.artworkId}-pub/_thumb_large.jpg`}
        alt="Submission Thumbnail"
        sx={{
          width: "60%",
          height: "auto",
          borderRadius: "25px",
          mb: 3,
        }}
      />
    </Box>
  );
};

export default ImageViewer;
